// QuizPage.tsx
import React, { useCallback, useState } from "react";
import NavBar from "../components/NavigationBar";
import MythSection from "../components/MythSection";
import { Box, Fade } from "@mui/material";
import { getAllQuestions } from "../myth_questions";
import "../styles/SourcesStyles.css";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations/translations";

const QuizPage: React.FC = () => {
  const SCROLL_THRESHOLD = 30;
  const COOLDOWN = 800;

  const { language } = useLanguage();
  const allQuestions = getAllQuestions(language);
  const totalSections = allQuestions.length;

  const t = translations[language].myths;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const handleWheel = useCallback(
    (event: React.WheelEvent<HTMLDivElement>) => {
      event.preventDefault();

      if (animating) return;
      if (Math.abs(event.deltaY) < SCROLL_THRESHOLD) return;

      const direction = event.deltaY > 0 ? "down" : "up";

      if (direction === "down" && currentIndex < totalSections - 1) {
        setAnimating(true);
        setCurrentIndex((i) => i + 1);
        setTimeout(() => setAnimating(false), COOLDOWN);
      } else if (direction === "up" && currentIndex > 0) {
        setAnimating(true);
        setCurrentIndex((i) => i - 1);
        setTimeout(() => setAnimating(false), COOLDOWN);
      }
    },
    [animating, currentIndex, totalSections]
  );

  if (totalSections === 0) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <NavBar />
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Keine Quizfragen definiert.
        </Box>
      </Box>
    );
  }

  const questionsForCurrentSection = allQuestions[currentIndex];

  const Titles = [t.myth1, t.myth2, t.myth3];

  const VideoSources = [
    "https://www.youtube.com/embed/QsKhGxIeToE",
    "https://www.youtube.com/embed/QsKhGxIeToE",
    "https://www.youtube.com/embed/QsKhGxIeToE",
  ];

  return (
    <Box
      onWheel={handleWheel}
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <NavBar />

      <Box
        sx={{
          flex: 1,
          pt: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "stretch",
          overflow: "hidden",
        }}
      >
        <Fade key={currentIndex} in={true} timeout={600}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
            }}
          >
            <MythSection
              reversed={currentIndex % 2 === 1}
              questions={questionsForCurrentSection}
              mythTitles={Titles[currentIndex]}
              youtubeUrl={VideoSources[currentIndex]}
            />
          </Box>
        </Fade>
      </Box>

      <Box
        sx={{
          position: "absolute",
          right: 24,
          bottom: 50,
          px: 3.5,
          py: 1.4,
          borderRadius: 999,
          bgcolor: "#5B8CB9",
          color: "#fff",
          fontSize: 16,
          fontWeight: 700,
          letterSpacing: 0.6,
          display: "flex",
          alignItems: "center",
          boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        }}
      >
        {currentIndex + 1} / {totalSections}
      </Box>
    </Box>
  );
};

export default QuizPage;
